import React, { useState } from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./categoriesStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";
import { Box } from "@mui/material";
import Button from "../../components/controls/Button";
import PageTitle from "../../components/pageTitle/PageTitle";

import AddCategoryDialog from "../../components/addCategoryDialog/AddCategoryDialog";
import EditCategoryDialog from "../../components/editCategoryDialog/EditCategoryDialog";
import { getCategoriesData } from "../../redux/reduser/categories";

function Categories() {
    const { t } = useTranslation();
    const classes = useStyles();
    const globalClasses = globalStyles();
    const { data, loading, error } = useSelector((state) => state.categories);
    const [openAddCategoryDialog, setOpenAddCategoryDialog] = useState(false);
    const [openEditCategoryDialog, setOpenEditCategoryDialog] = useState(false);
    const [index, setIndex] = useState(null);
  
    const handleClose = () => {
      setOpenAddCategoryDialog(false);
    };
    const handleCloseEditAdminDialog = () => {
      setOpenEditCategoryDialog(false);
    };
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getCategoriesData());
    }, []);
  
    const columns = [
      { name: t("id") },
      { name: t("name") },
      {name:t("description")},
    
      { name: t("image") ,
    
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <img
            height="80px"
            width="80px"
              
              src={"https://thumbs.dreamstime.com/b/no-image-available-icon-flat-vector-no-image-available-icon-flat-vector-illustration-132482930.jpg"}
              
            />
          );
        },
      },
    },
      {
        name: t(""),
        options: {
          filter: false,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            return (
              <Button
                className={classes.btn}
                color="primary"
                disabled={false}
                onClick={() => {
                 setIndex(dataIndex);
                 setOpenEditCategoryDialog(true);
                 
                }}
                text={t("edit")}
              />
            );
          },
        },
      },
    ];
  
    return (
      <Box className={globalClasses.background}>
      <Box className={globalClasses.page}>
      <Box className={globalClasses.row}>
       <PageTitle title={t("categories")}/>
     
                 <Button
              className={classes.btn}
             
              variant="contained"
              color="primary"
              disabled={false}
              onClick={()=>{
           
                setOpenAddCategoryDialog(true);
              }}
              type="submit"
              text={t("addCategory")}
            />
      </Box>
      <Box >
      <AddCategoryDialog open={openAddCategoryDialog} handleClose={handleClose} close={t("close")} 
       title={ t("addCategory")}  
      />
       <EditCategoryDialog open={openEditCategoryDialog} handleClose={handleCloseEditAdminDialog} close={t("close")} 
     title={ data!=[] && index!=null?data[index][1]:""}  data={data!=[]?data[index]:""}
      />
        {loading === true ? (
          <div className={globalClasses.center}>
            {" "}
            <CircularProgressBar />{" "}
          </div>
        ) : error == null ? (
          <UseTable
            data={data}
            columns={columns}
            title={t("categories")}
            selectableRows={true}
          />
        ) : (
          <div className={globalClasses.center}>
            {" "}
            <ErrorMessage title={error} />{" "}
          </div>
        )}
      </Box>
      
      </Box>
      </Box>
    );
  }
export default Categories
